import { theme as antdTheme, type ThemeConfig } from "antd";

export type Mode = "day" | "night" | "sepia";

/** Theme config for a given mode + font size (mirrors the baseline admin's day/night/sepia). */
export function themeFor(mode: Mode, fontSize: number): ThemeConfig {
  if (mode === "night") return { algorithm: antdTheme.darkAlgorithm, token: { borderRadius: 8, fontSize } };
  if (mode === "sepia") return { token: { borderRadius: 8, fontSize, colorBgLayout: "#f1e7d0", colorBgContainer: "#fbf6e9" } };
  return { token: { borderRadius: 8, fontSize } };
}

export const FONT_SIZES = [12, 13, 15] as const; // A- / A / A+
